import { useEffect, useState } from "react";

const LINKS = [
  { label: "Exhibition", href: "#exhibition" },
  { label: "Artist", href: "#artist" },
  { label: "Gallery", href: "#gallery" },
  { label: "Journey", href: "#journey" },
  { label: "Updates", href: "#updates" },
  { label: "Visit", href: "#visit" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled
          ? "pl-nav-blur border-b text-[#F5F0E8]"
          : "bg-transparent text-[#F5F0E8] border-b border-transparent"
      }`}
      style={
        scrolled
          ? {
              backgroundColor: "rgba(10, 10, 10, 0.72)",
              borderBottomColor: "rgba(245, 240, 232, 0.06)",
            }
          : undefined
      }
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          aria-label="Première Ligne — return to top"
          className={`flex items-baseline gap-2 group transition-opacity duration-300 ${
            scrolled
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
        >
          <span className="font-serif-display text-2xl md:text-3xl font-bold tracking-tight">
            Première<span className="text-[#C41E1E]">.</span>
          </span>
          <span
            className={`hidden sm:inline text-[10px] uppercase tracking-[0.25em] ${
              scrolled ? "text-[#F5F0E8]/60" : "text-white/70"
            }`}
          >
            Ligne
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="pl-link text-[11px] uppercase tracking-[0.25em] font-medium hover:text-[#C41E1E] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#newsletter"
          data-testid="nav-cta-rsvp"
          className="hidden md:inline-flex pl-cta pl-cta-primary"
        >
          Stay Connected
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="block w-6 h-[1.5px] bg-current mb-[6px]" />
          <span className="block w-6 h-[1.5px] bg-current mb-[6px]" />
          <span className="block w-4 h-[1.5px] bg-current ml-auto" />
        </button>
      </div>

      {/* Mobile menu — fades and lifts in/out instead of snapping */}
      <div
        data-testid="nav-mobile-panel"
        aria-hidden={!open}
        className={`lg:hidden bg-[#0A0A0A] text-[#F5F0E8] border-t border-[#C41E1E]/40 overflow-hidden transition-[max-height,opacity] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          open
            ? "max-h-[520px] opacity-100"
            : "max-h-0 opacity-0 pointer-events-none"
        }`}
      >
        <ul className="px-6 py-8 space-y-5">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={() => setOpen(false)}
                className="block font-serif-display text-2xl hover:text-[#C41E1E] transition-colors duration-500"
              >
                {l.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#newsletter"
              onClick={() => setOpen(false)}
              className="inline-flex mt-4 pl-cta pl-cta-primary"
            >
              Stay Connected
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
